import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomDeleteRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomDeleteRequestDTORaw) {
    JsonSchemaValidator.assert(RoomDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      },
      additionalProperties: false
    };
  }
}

interface RoomDeleteRequestDTORaw {
  roomId: RoomId;
}
